/*------------------------------------*\
	#TAB (LAYOUT)
\*------------------------------------*/

function openTab(evt, tabName) {
	// Declare all variables
	var i, tabcontent, tablinks;

	// Get all elements with class="tabcontent" and hide them
	tabcontent = document.getElementsByClassName("js-tab-border-content");
	for (i = 0; i < tabcontent.length; i++) {
		tabcontent[i].style.display = "none";
	}

	// Get all elements with class="tablinks" and remove the class "active"
	tablinks = document.getElementsByClassName("js-tab-border-links");
	for (i = 0; i < tablinks.length; i++) {
		tablinks[i].className = tablinks[i].className.replace(" active", "");
	}

	// Show the current tab, and add an "active" class to the button that opened the tab
	if (tabName) {
		document.getElementById(tabName).style.display = "block";
	}
	if (evt) {
		evt.currentTarget.className += " active";
	}

}

window.addEventListener('DOMContentLoaded', (event) => {
	openTab();

	if (document.getElementById('tbcontact')) {
		document.getElementById('tbcontact').style.display = "block";
		document.getElementById('tabcontact').className += " active";
	}
});
